export default __webpack_public_path__ + "static/media/img5.e0161090.jpg";